const projects = [
    {
        id:1,
        imgUrl: "./assets/project-images/project7.webp",
        sqImgUrl: "./assets/project-images/sqproject7.webp",
        name: 'Weatherline',
        type: "Web Application",
        gist: 'Live Weather App',
        description: [
            "I developed this application as prep for a Web Development Workshop organized by my fellow members of the DeCoders Programming Club at SIT.",
        ],
        technicalSheet: [
            "HTML",
            "SCSS",
            "JavaScript",
        ],
        liveUrl: 'https://weather-api-123.netlify.app/',
        codeUrl: 'https://github.com/Aprameya-S/Travel-Blog',
    },
    {
        id:2,
        imgUrl: "./assets/project-images/project6.webp",
        sqImgUrl: "./assets/project-images/sqproject6.webp",
        name: 'CSS Tricks Clone',
        type: "Website",
        gist: 'Improved Navbar UI',
        description: [
            "This was my first frontend project, which I built as part of the Frontend Mentor Challenges program. To enhance the user experience, I implemented a better navbar with a hamburger menu, replacing the original site's horizontal scroll menu.",
        ],
        technicalSheet: [
            "HTML",
            "CSS",
            "JavaScript",
        ],
        liveUrl: 'https://css-tricks-clone.netlify.app/',
        codeUrl: 'https://github.com/Aprameya-S/Travel-Blog',
    },
    {
        id:3,
        imgUrl: "./assets/project-images/project5.webp",
        sqImgUrl: "./assets/project-images/sqproject5.webp",
        name: 'Sphere',
        type: "Three.js Experiment",
        gist: 'Three.js Experiment',
        description: [
            "Three.js and React.js project that is optimised for all display types, with variable refresh rate and resolution. I made this project while exploring new technologies in the frontend domain. Blender was used to generate the normal map for the sphere.",
        ],
        technicalSheet: [
            "HTML",
            "CSS",
            "JavaScript",
            "React.js",
            "Three.js",
            "Blender"
        ],
        liveUrl: 'https://feelthesphere-3js.netlify.app/',
        codeUrl: 'https://github.com/Aprameya-S/Travel-Blog',
    },
    {
        id:4,
        imgUrl: "./assets/project-images/project4.webp",
        sqImgUrl: "./assets/project-images/sqproject4.webp",
        name: 'TravelLord',
        type: "Web Application",
        gist: 'A statically generated micro-blogging website built with Eleventy and Nunjucks.',
        description: [
            "A micro blogging site that uses Eleventy and Nunjucks for static site generation. The site uses markup files to store data directly on Github. Uses Netlify Auth and CMS.",
        ],
        technicalSheet: [
            "HTML",
            "Nunjucks",
            "JavaScript",
            "CSS",
            "Eleventy",
        ],
        liveUrl: 'https://travelord.netlify.app/',
        codeUrl: 'https://github.com/Aprameya-S/Travel-Blog',
    },
    {
        id:5,
        imgUrl: "./assets/project-images/project3.webp",
        sqImgUrl: "./assets/project-images/sqproject3.webp",
        name: 'Minesweeper',
        type: "Online Game",
        gist: 'Online version of the game built with React.js.',
        description: [
            "An online version of Minesweeper with gamified UI. This has to be one of my proudest projects because the feature list cuts across some very challenging and exciting frontend sectors.",
        ],
        technicalSheet: [
            "React.js",
            "SCSS",
        ],
        liveUrl: 'https://minesvveeper.netlify.app/',
        codeUrl: 'https://github.com/Aprameya-S/Minesweeper',
    },
    {
        id:6,
        imgUrl: "./assets/project-images/project2.webp",
        sqImgUrl: "./assets/project-images/sqproject2.webp",
        name: 'BROWSE',
        type: "Website",
        gist: 'A website for the Annual Technical Symposium organized by the IT departments of Siddaganga Institute of Technology.',
        description: [
            "As part of SARK - a technical club under the aegis of the Department of Information Science and Engineering, a fellow member and I developed A website for the Annual Technical Symposium organized by the IT departments of Siddaganga Institute of Technology.",
            "The application served as medium for over 300 registrations across varios colleges."
        ],
        technicalSheet: [
            "PHP",
            "HTML",
            "JavaScript",
            "MySQL",
            "CSS"
        ],
        liveUrl: 'http://browse.sit.ac.in/',
        codeUrl: '',
    },
    {
        id:7,
        imgUrl: "./assets/project-images/project1.webp",
        sqImgUrl: "./assets/project-images/sqproject1.webp",
        name: 'Certificio',
        type: "Web Application",
        gist: 'An application which generates certificates on the go complete with authentication for security.',
        description: [
            "Being part of the technical club SARK, we had to individually mail certificates to event participants or resort to third party services for certificate distribution. To tackle this problem I developed Certificio - an application which generates certificates on the go complete with authentication for security."
        ],
        technicalSheet: [
            "React.js",
            "Firebase",
            "SCSS",
        ],
        liveUrl: 'https://certificio.netlify.app/login',
        codeUrl: '',
    },
    {
        id:8,
        imgUrl: "./assets/project-images/project8.webp",
        sqImgUrl: "./assets/project-images/sqproject8.webp",
        name: 'VitalFund',
        type: "Web3 Application",
        gist: 'An online platform that facilitates multi-user crowd funding for health-related campaigns.',
        description: [
            "An online platform that facilitates multi-user crowdfunding for health-related and medical research campaigns. The goal of this project is to develop an online crowdfunding platform for healthcare that utilizes blockchain technology and cryptocurrency transactions to provide secure, transparent, and efficient funding for medical treatments.",
            "Users can easily connect to their Metamask wallet or other compatible wallets and seamlessly initiate their fundraising efforts with minimal effort. The platform offers an intuitive interface that supports the uploading of an image for visual reference and a comprehensive description of their medical condition. Users can effortlessly browse all active campaigns, connect their wallets, and make donations to the campaign of their choice. To track and monitor all their activities and transactions, both donors and beneficiaries can conveniently access their profiles page."
        ],
        technicalSheet: [
            "React.js",
            "Thirdweb",
            "Node.js",
            "Hardhat",
            "Remix",
            "VM Instances(GCP)",
            "Metamask",
            "Solidity",
            "SASS",
            "Smart contracts",
            "Tailwind CSS"
        ],
        liveUrl: 'https://vitalfund.netlify.app/',
        codeUrl: 'https://github.com/Aprameya-S/VitalFund',
    },
    {
        id:9,
        imgUrl: "./assets/project-images/project10.webp",
        sqImgUrl: "./assets/project-images/sqproject10.webp",
        name: 'DeCoders',
        type: "Web Application",
        gist: 'Club website and multi-user quiz application.',
        description: [
            "A website with an intuitive user interface with an admin panel that provides complete oversight and allows easy monitoring, content management, and real-time updates.",
            "The quiz platform also has an admin panel which acts as a content management system. The platform supports multi-role authentication using JWT. Multiple anti-cheating measures like window-focus, full screen mode and key stroke detection are also implemented."
        ],
        technicalSheet: [
            "React.js",
            "GSAP",
            "Node.js",
            "MongoDB",
            "SASS",
            "JWT",
            "Firebase",
            "Tailwind CSS"
        ],
        liveUrl: 'https://www.decoderssit.com/',
        codeUrl: '',
    },
    {
        id:10,
        imgUrl: "./assets/project-images/project9.webp",
        sqImgUrl: "./assets/project-images/sqproject9.webp",
        name: 'LawVertex',
        type: "Web3 Application",
        gist: 'Club website and multiplayer quiz application.',
        description: [
            "A private file storage and sharing system using IPFS and blockchain alongside an Ethereum based alternative to existing eCourts(legal data repository) system to overcome the issues of data tampering, redundancies and missing data. Attorney details for each case are linked to their respective profiles in the attorney searching platform resulting in a permanent tamper proof track record of the attorney’s cases.",
            "Implemented a variant of AES-256 algorithm for file encryption with an average of 86% improvement in encryption and 50% greater avalanche effect."
        ],
        technicalSheet: [
            "Next.js",
            "Solidity",
            "Truffle",
            "Ganache",
            "MongoDB",
            "IPFS",
            "Remix",
            "Thirdweb",
            "GSAP",
            "SASS",
            "Shadcn",
            "Tailwind CSS"
        ],
        liveUrl: 'https://lawvertex.vercel.app/',
        codeUrl: 'https://github.com/Aprameya-S/LawVertex',
    },
]
export default projects.reverse()